var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTable2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.74627 8C7.4058 8 5.22018 9.16971 3.92192 11.1171L3.03645 12.4453C2.59342 13.1099 3.06981 14 3.8685 14H4.24999V19C4.24999 19.4142 4.58577 19.75 4.99999 19.75C5.4142 19.75 5.74999 19.4142 5.74999 19V14H7.24999V16.5C7.24999 16.9142 7.58577 17.25 7.99999 17.25C8.4142 17.25 8.74999 16.9142 8.74999 16.5V14H15.25V16.5C15.25 16.9142 15.5858 17.25 16 17.25C16.4142 17.25 16.75 16.9142 16.75 16.5V14H18.25V19C18.25 19.4142 18.5858 19.75 19 19.75C19.4142 19.75 19.75 19.4142 19.75 19V14H20.1315C20.9302 14 21.4066 13.1099 20.9635 12.4453L20.0781 11.1171C18.7798 9.16971 16.5942 8 14.2537 8H9.74627Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTable2);
export default __webpack_public_path__ + "static/media/table-2.94c3859b59bc8a7f7e3233057f2eb9ec.svg";
export { ForwardRef as ReactComponent };